import StoreModuleService from '../StoreModuleService';
import { getWorkflow } from '../workflows/getters';
import { MODULE_NAME } from './const';

const buildProjectGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const data = buildProjectGetterObject('data');
export const projectsList = buildProjectGetterObject('projectsList');
export const loadedProjectsFlag = buildProjectGetterObject('loadedProjectsFlag');
export const getProject = buildProjectGetterObject('getProject');
export const getProjectFlows = buildProjectGetterObject('getProjectFlows');
export const totalNumOfFlowsForProject = buildProjectGetterObject('totalNumOfFlowsForProject');
export const projectSharedData = buildProjectGetterObject('projectSharedData');
export const projectSharedDataLoading = buildProjectGetterObject('projectSharedDataLoading');
export const projectPermissions = buildProjectGetterObject('projectPermissions');
export const projectHasPermission = buildProjectGetterObject('projectHasPermission');

const getters = {
	[data.getter]: (state) => state.data,
	[projectsList.getter]: (state) => Object.values(state.data),
	[loadedProjectsFlag.getter]: (state) => state.loadedProjectsFlag,
	[getProject.getter]: (state) => (projectId) => state.data[projectId],
	[getProjectFlows.getter]: (state, getters, rootState, rootGetters) => (projectId) => {
		const project = getters[getProject.getter](projectId);
		const projectFlows = [];
		if (project) {
			project.flows.forEach((workflowId) => {
				const workflow = rootGetters[getWorkflow.fullPath](workflowId);
				if (workflow) {
					projectFlows.push(workflow);
				}
			});
		}
		return projectFlows;
	},
	[projectHasPermission.getter]: (state) => (projectId, permission_to_check) =>
		(state.permissions[projectId] || []).includes(permission_to_check),
	[projectPermissions.getter]: (state) => (projectId) => state.permissions[projectId],
	[projectSharedData.getter]: (state) => (projectId) => state.sharedData[projectId],
	[projectSharedDataLoading.getter]: (state) => state.sharedDataLoading,
	[totalNumOfFlowsForProject.getter]: (state, getters) => (projectId) =>
		getters[getProject.getter](projectId)?.flows ? getters[getProject.getter](projectId).flows.length : 0,
};

export default getters;
